import React, { useEffect, useState } from "react";
import { IAutomation } from "../../interfaces/IAutomation";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { AutomationMailRow } from "./AutomationMailRow";
import { IRole } from "../../interfaces/IRole";
import { ITaskState } from "../../interfaces/ITaskState";
import { ITaskType } from "../../interfaces/ITaskType";
import { ITaskPriority } from "../../interfaces/ITaskPriority";
import { AutomationTaskRow } from "./AutomationTaskRow";
import { AutomationTaskEdit, getEmptyAutomationTask } from "./AutomationTaskEdit";

interface IProps {
    automation: IAutomation;
    setAutomation: Function;
    roleArray: IRole[];
    //
    taskStateArray: ITaskState[];
    taskTypeArray: ITaskType[];
    taskPriorityArray: ITaskPriority[];
}

export const AutomationTaskCard: React.FC<IProps> = ({
    automation,
    setAutomation,
    roleArray,
    taskStateArray,
    taskTypeArray,
    taskPriorityArray,
}) => {
    const [autoTaskArray, setAutoTaskArray] = useState(automation.AutomationTaskArray);
    //
    const [isOpenNew, setIsOpenNew] = useState(false);
    const [newAutoTask, setNewAutoTask] = useState(
        getEmptyAutomationTask(automation.AutomationTaskArray, automation.id),
    );

    const handleOnNew = () => {
        setNewAutoTask(getEmptyAutomationTask(automation.AutomationTaskArray, automation.id));
        setIsOpenNew(true);
    };
    const handleSave = () => {
        setAutoTaskArray([...autoTaskArray, newAutoTask]);
        setIsOpenNew(false);
    };

    useEffect(() => {
        setAutomation({
            ...automation,
            AutomationTaskArray: [...autoTaskArray],
        });
    }, [autoTaskArray]);

    return (
        <>
            {isOpenNew && (
                <Dialog open onClose={() => setIsOpenNew(false)} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <AutomationTaskEdit
                            autoTask={newAutoTask}
                            setAutoTask={setNewAutoTask}
                            roleArray={roleArray}
                            taskPriorityArray={taskPriorityArray}
                            taskStateArray={taskStateArray}
                            taskTypeArray={taskTypeArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenNew(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Card variant="outlined">
                <CardContent>
                    <Typography>
                        Automatische Aufgaben
                        <Button sx={{ float: "right" }} variant="outlined" onClick={handleOnNew}>
                            Hinzufügen
                        </Button>
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Status</TableCell>
                                <TableCell>Priotität</TableCell>
                                <TableCell>An (Rollen)</TableCell>
                                <TableCell>Titel</TableCell>
                                <TableCell width={100}>Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {automation.AutomationTaskArray.map((task) => (
                                <AutomationTaskRow
                                    key={`task-edit-${task.id}`}
                                    autoTask={task}
                                    autoTaskArray={autoTaskArray}
                                    setAutoTaskArray={setAutoTaskArray}
                                    roleArray={roleArray}
                                    taskPriorityArray={taskPriorityArray}
                                    taskStateArray={taskStateArray}
                                    taskTypeArray={taskTypeArray}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    );
};
